<div class="mb-3" data-test-class="items-slider">
	<div [id]="'items-slider-' + uid()" class="relative">
		<div
			[class]="
				cn(
					'absolute left-0 top-1/2 z-10 hidden size-16 -translate-x-1/2 -translate-y-1/2 cursor-default rounded-full bg-white',
					hasNav() && 'lg:flex'
				)
			"
		></div>
		<button
			#prevButton
			[class]="
				cn(
					'absolute left-0 top-1/2 z-10 hidden size-12 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-primary-100 hover:bg-primary-125 active:bg-primary-150 disabled:cursor-not-allowed disabled:bg-primary-100 disabled:opacity-50',
					hasNav() && 'lg:flex'
				)
			"
			aria-label="Previous slide"
			data-test-id="slide-prev"
			type="button"
		>
			<svg-icon
				class="block size-5 text-white"
				src="assets/icons/icon-chevron-left.svg"
			/>
		</button>
		<swiper-container #swiper class="relative flex flex-row" init="false">
			@for (item of items(); track trackFn()(item)) {
				<swiper-slide
					class="size-auto"
					data-test-class="swiper-slide"
					lazy="true"
				>
					<ng-container
						[ngTemplateOutlet]="itemTemplate()"
						[ngTemplateOutletContext]="{ $implicit: item }"
					/>
				</swiper-slide>
			}
		</swiper-container>
		<div
			[class]="
				cn(
					'absolute right-0 top-1/2 z-10 hidden size-16 -translate-y-1/2 translate-x-1/2 cursor-default rounded-full bg-white',
					hasNav() && 'lg:flex'
				)
			"
		></div>
		<button
			#nextButton
			[class]="
				cn(
					'absolute right-0 top-1/2 z-10 hidden size-12 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full bg-primary-100 hover:bg-primary-125 active:bg-primary-150 disabled:cursor-not-allowed disabled:bg-primary-100 disabled:opacity-50',
					hasNav() && 'lg:flex'
				)
			"
			aria-label="Next slide"
			data-test-id="slide-next"
			type="button"
		>
			<svg-icon
				class="block size-5 text-white"
				src="assets/icons/icon-chevron-right.svg"
			/>
		</button>
	</div>
	<div class="mt-4 flex justify-center">
		<div
			#paginationEl
			class="pagination flex flex-row items-center gap-2"
			data-test-id="pagination"
		></div>
	</div>
</div>
